const initialState = {
    tasks: [],
    };
const appReducer = (state = initialState, action:any) => {
    return state;
    };
    export default appReducer;